module.exports = __webpack_public_path__ + "img/1559975109.aa36a495.jpg";